import ValidityHelper from '../../../Helpers/ValidityHelper';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import ReportRunnerService from '../../../Services/ReportRunnerSerivce';
import EvaluatorCountReportSearchParams from './EvaluatorCountReportSearchParams';

export default class EvaluatorCountReportWindowDescription {
  static titleForCreate = 'Evaluator Count Report';
  static titleForEdit = 'Evaluator Count Report';
  static itemType = EvaluatorCountReportSearchParams;
  static serviceFunction = ReportRunnerService.RequestEvaluatorCountReport;
  static waitForServiceFunction = () => false;
  static finishButtonLabel = 'Export';
  static messageOnSuccess =
    'File creation has started and your report will be available in your personal download menu soon. You can continue to use the system while your request is being processed.';

  static pagesInGeneralEditWizzard = [
    {
      label: 'General',
      fields: [
        {
          fieldName: 'OfficeIds',
          label: 'FW Office',
          className: 'col-12',
          type: InputTypesEnum.OfficeOrGroupMultiSelect,
          validityChecker: ValidityHelper.forRequiredSelectField,
        },
        {
          fieldName: 'CountryCodes',
          label: 'Country',
          className: 'col-12',
          type: InputTypesEnum.CountryCodeMultiChoice,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'GroupBy',
          label: 'Group By',
          className: 'col-12',
          type: InputTypesEnum.MultiChoice,
          selectvalues: EvaluatorCountReportWindowDescription.GetGroupByOptions(),
          validityChecker: ValidityHelper.forRequiredMultiSelectField,
        },
      ],
    },
  ];

  static GetGroupByOptions() {
    return [
      { value: 'office', label: 'Office' },
      { value: 'country', label: 'Country' },
      { value: 'state', label: 'State' },
      { value: 'city', label: 'City' },
    ];
  }
}
